<template>
  <el-select 
    v-model="internalValue"
    :disabled="disabled"
    :teleported="false"
    :popper-options="popperOptions"
    :popper-class="popperClass"
    :placeholder="placeholder"
    filterable 
    default-first-option
    no-match-text="No matches found"
    no-data-text="No options available"
    @change="$emit('change')"
  >
    <slot />
  </el-select>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import PopperAssistant from '@/helpers/popper-assistant'

/* Wrapper class for single selects */
export default defineComponent({
  name: 'SingleSelect',

  props: {
    modelValue: {
      type: [String, Number, Boolean, Date],
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    popperClass: {
      type: String,
      default: '',
    },
  },

  emits: ['change', 'update:modelValue'],

  data() {
    return {
      // Fixed inside dialogs and drawers, so their scrolling body doesn't cut the dropdown off
      popperOptions: {},
    }
  },

  computed: {
    internalValue: {
      get(): any {
        return this.modelValue
      },
      set(value: any): any {
        this.$emit('update:modelValue', value)
      },
    },
  },

  mounted() {
    this.popperOptions = PopperAssistant.inPlacePopperOptions(this.$el)
  },
})
</script>
